import VerifiedIcon from '@mui/icons-material/Verified'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

export const SEVERITY_LEVELS = {
  NO_HISTORY: 'noHistory',
  PUNCTUAL: 'punctual',
  WARNING: 'warning',
  LATE: 'late',
}

export const SEVERITY_THRESHOLDS = {
  warning: 20,
  late: 50,
}

export function getSeverityLevel(percent, totalTurns = 0) {
  if (!totalTurns) return SEVERITY_LEVELS.NO_HISTORY
  if (percent >= SEVERITY_THRESHOLDS.late) return SEVERITY_LEVELS.LATE
  if (percent >= SEVERITY_THRESHOLDS.warning) return SEVERITY_LEVELS.WARNING
  return SEVERITY_LEVELS.PUNCTUAL
}

export function toPercent(ratio) {
  const num = Number(ratio) || 0
  const pct = num <= 1 ? num * 100 : num
  return Math.max(0, Math.min(100, Math.round(pct)))
}

export function getSeverityLabel(level) {
  if (level === SEVERITY_LEVELS.NO_HISTORY) return 'SIN HISTORIAL'
  if (level === SEVERITY_LEVELS.LATE) return 'FALTADOR'
  if (level === SEVERITY_LEVELS.WARNING) return 'ATENCIÓN'
  return 'PUNTUAL'
}

export function getSeverityIcon(level) {
  if (level === SEVERITY_LEVELS.LATE) return WarningAmberIcon
  if (level === SEVERITY_LEVELS.WARNING) return WarningAmberIcon
  return VerifiedIcon
}

export function getSeverityHelpText(level) {
  if (level === SEVERITY_LEVELS.NO_HISTORY) return 'Sin historial suficiente'

  if (level === SEVERITY_LEVELS.LATE || level === SEVERITY_LEVELS.WARNING) {
    return 'Pedir seña antes de confirmar'
  }

  return 'Buen historial de asistencia'
}

export function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural
}

export function getTurnsPeriodText(totalTurns = 0) {
  if (totalTurns === 0) return ''
  if (totalTurns === 1) return 'en el último turno'

  return `en los últimos ${totalTurns} turnos`
}

export function getAbsenteeismSummaryText(absentTurns = 0, totalTurns = 0) {
  if (!totalTurns) return 'Sin turnos previos registrados'

  const absenceText = pluralize(absentTurns, 'ausencia', 'ausencias')
  const turnsPeriodText = getTurnsPeriodText(totalTurns)

  return `${absentTurns} ${absenceText} ${turnsPeriodText}`
}
